import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { hasMedia, targetSummary } from '../../helpers/scope_wheel_helpers';
import './WheelHeroCard.scss';

const WheelHeroCard = ({ hero, isSelected, onSelect, children }) => (
  <div className={cn('wheel-hero-card', { selected: isSelected, dim: hero.status !== 'accepted' })}>
    <button type='button' className='wheel-hero-card-summary' onClick={onSelect}>
      <div className='wheel-hero-card-media'>
        {hero.imageUrl ? (
          <img src={hero.imageUrl} alt='' loading='lazy' />
        ) : (
          <div className='wheel-hero-card-empty'>{hero.videoUrl ? 'Video · add poster' : 'No media'}</div>
        )}
      </div>
      <div className='wheel-hero-card-body'>
        <div className='wheel-hero-card-term'>{hero.term || 'Untitled'}</div>
        <div className='wheel-hero-card-meta'>
          <span>{targetSummary(hero)}</span>
          {hero.status === 'accepted' && <span>{hero.isLive && hasMedia(hero) ? 'Live' : 'Draft'}</span>}
        </div>
      </div>
    </button>
    {isSelected && children}
  </div>
);

WheelHeroCard.propTypes = {
  hero: PropTypes.object.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default WheelHeroCard;
